import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { TemplatesState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import {TemplateItemImpl} from './types'

export const state: TemplatesState = {
    templates: [],
    allTemplates: [],
    multichannelTemplates: [],
    distributions: [],
    templateObject: new TemplateItemImpl()
};


export const template: Module<TemplatesState,RootState> = {
    state,
    getters,
    actions,
    mutations
};